module.exports = __webpack_public_path__ + "img/picture-3.cc3809ee.png";